module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order"
  }, [(_vm.title) ? _c('h1', {
    staticClass: "order__title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('div', {
    staticClass: "order__order"
  }, [_vm._v(_vm._s(_vm.defaultText)), _c('div', {
    staticClass: "order__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  })]), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43d1535a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderHeader.vue
// module id = 0fe1933174bccd969277
// module chunks = 0